const url = import.meta.env.VITE_APP_API_ACCOUNT

export default {
    actions: {
        fetchCurrencies: async ({ commit, dispatch }, withAccount = true) => {
            try {
                const  resJson = await fetch(`${url}/currency/list`)
                const res = await resJson.json()
                if(res.code === 200) {
                    commit('SET_CURRENCIES', res.data.items)


                    if(withAccount) {
                        dispatch('connectAccount')
                    }
                    return  res.data.items;
                }
            } catch (e) {

            }
        },
        connectAccount: ({ commit, getters }) => {
            const {getCurrencies, getAccounts} = getters
        }
    },
    mutations: {
        SET_CURRENCIES(state, list) {
            state.currencies = list
        }
    },
    state: {
        currencies: [],
    },
    getters: {
        getCurrencies:(state) => state.currencies,
    }
}